import { css } from '@emotion/css';

export const editableInputStyles = css`
  box-shadow:
    rgba(15, 15, 15, 0.05) 0px 0px 0px 1px,
    rgba(15, 15, 15, 0.1) 0px 3px 6px,
    rgba(15, 15, 15, 0.2) 0px 9px 24px;
`;

export const rectPositionStyles = ({ top, left, width, height }: DOMRect) => css`
  top: ${top}px;
  left: ${left}px;
  width: ${width}px;
  min-height: ${height}px;
  min-width: 30rem;
  max-height: 30rem;
`;
